import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from 'ish-shared/shared.module';

import { ContentPageSelectionComponent } from './content-page-selection/content-page-selection.component';
import { ContentPageComponent } from './content-page.component';

const contentPageRoutes: Routes = [
  {
    // compatibility to old routes
    path: 'page/:contentPageId', //DIAS CUSTOMIZATION
    component: ContentPageSelectionComponent,
    // canActivate: [dotCmsUveGuard],
  },
  // {
  //   // compatibility to old routes
  //   path: 'page/:contentPageId', //DIAS CUSTOMIZATION
  //   component: DotCmsUvePageComponent,
  //   canActivate: [dotCmsUveGuard],
  // },
  {
    path: '**',
    component: ContentPageSelectionComponent,
    // canActivate: [dotCmsUveGuard],
  },
  // {
  //   path: '**',
  //   component: ContentPageSelectionComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forChild(contentPageRoutes), SharedModule],
  declarations: [ContentPageComponent, ContentPageSelectionComponent],
})
export class ContentPageModule {}
